export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.moduleId = item != null ? item.moduleId : ''
        this.deleted = item != null ? item.deleted ? 'true' : 'false' : 'false'
        this.companyId = item != null ? item.companyId : ''
        this.moduleName = item != null ? item.moduleName : ''
        this.companyName = item != null ? item.companyName : ''
    }
}